import { actionTypes } from '../actions';

const initialState = {
  services: [],
  service: {},
  agreement: [],
  agreementLoading: false,
  loading: false,
};

export default (state = {...initialState}, action) => {
  switch (action.type) {
    case actionTypes.FEATURED_SERVICES:
      return {
        ...state,
      };
    case actionTypes.FEATURED_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.payload,
      };
    case actionTypes.FEATURED_SERVICES_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case actionTypes.FEATURED_SERVICE:
      return {
        ...state,
        loading: true
      };
    case actionTypes.FEATURED_SERVICE_SUCCESS:
      return {
        ...state,
        service: action.payload,
        loading: false,
      };
    case actionTypes.FEATURED_SERVICE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case actionTypes.RESET_FEATURED_SERVICE:
      return {
        ...state,
        service: {},
        agreement: [],
      };
    case actionTypes.FEATURED_AGREEMENT:
      return {
        ...state,
        agreementLoading: true,
      };
    case actionTypes.FEATURED_AGREEMENT_SUCCESS:
      return {
        ...state,
        agreement: action.payload.results,
        agreementLoading: false,
      };
    case actionTypes.FEATURED_AGREEMENT_FAILURE:
      return {
        ...state,
        agreementLoading: false,
      };
    case actionTypes.LOGGED_OFF:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/featuredService.js